const { default: Swiper } = require('swiper');
const { EffectFade, Navigation } = require('swiper/modules');

const sections = document.querySelectorAll('section.foto-gallery');

if (sections.length) {
    sections.forEach(element => {
        const swiperEl = element.querySelector('.swiper-slider');
        const prevEl = element.querySelector('[swiper-prev]');
        const nextEl = element.querySelector('[swiper-next]');
        if (swiperEl) {
            const swiper = new Swiper(swiperEl, {
                slidesPerView: 1,
                modules: [EffectFade, Navigation],
                effect: 'fade',
                loop: true,
                fadeEffect: {
                    crossFade: true,
                },
                navigation: {
                    prevEl,
                    nextEl,
                },
            });
        }
    });
}
